<template>
    <el-dialog v-dialogDrag class="selDialog" width="1000px" :visible.sync="dialogVisible"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                销售合同明细选择
            </div>
        </div>
        <div class="dialog_body">
            <div style="padding: 10px;height: 40px;margin-bottom:20px">
                <searchBar :searchData="searchData" @search="search">
                </searchBar>
            </div>
            <el-table
                    ref="table"
                    :data="dataList"
                    height="400"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    @row-click="rowClick"
                    row-key="id"
                    border>
                <el-table-column
                        type="index"
                        :index="(pageInfo.page-1) * pageInfo.pagesize+1"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        type="selection"
                        prop="_dx"
                        label="选择"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="departmentNameBill"
                        label="所属部门"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="billNo"
                        label="合同编号"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="contractName"
                        label="合同名称"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="typeName"
                        width="150"
                        label="物资类别">
                </el-table-column>
                <el-table-column
                        prop="proCode"
                        width="150"
                        label="物资编码">
                </el-table-column>
                <el-table-column
                        prop="proName"
                        width="150"
                        label="物资名称">
                </el-table-column>
                <el-table-column
                        prop="units"
                        width="150"
                        label="计量单位">
                </el-table-column>
                <el-table-column
                        prop="icon"
                        width="150"
                        label="规格型号">
                </el-table-column>
                <el-table-column
                        prop="num"
                        width="150"
                        label="数量">
                </el-table-column>
                <el-table-column
                        prop="taxPrice"
                        width="120"
                        label="含税单价">
                </el-table-column>
                <el-table-column
                        prop="taxTotal"
                        width="120"
                        label="含税小计">
                </el-table-column>
                <el-table-column
                        prop="origin"
                        width="150"
                        label="产地">
                </el-table-column>
                <el-table-column
                        prop="color"
                        width="150"
                        label="颜色">
                </el-table-column>
                <el-table-column
                        prop="batch"
                        width="250"
                        label="批次">
                </el-table-column>
                <el-table-column
                        prop="minSalePrice"
                        width="100"
                        label="最低销售价">
                </el-table-column>
                <el-table-column
                        prop="costPrice01"
                        width="100"
                        label="成本价">
                </el-table-column>
            </el-table>

            <div class="pagStyle">
                <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
            </div>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="primary" @click="submit">确 定</el-button>
                <el-button type="danger" @click="close">取 消</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import searchBar from '@/components/tools/toolBar/searchBar/build'
    import pagination from "@/components/tools/table/pagination";

    export default {
        name: "selBill",
        props: ['selId',"relaBillId"],
        components:{
            searchBar,pagination
        },
        data() {
            return {
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "关键字搜索",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                dialogVisible: true,
                dialoading: false,
                dataList: [],
            }
        },
        async mounted() {
            await this.getListData();
            if(this.selId){
                this.defaultSelect();
            }
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async search(){
                this.pageInfo.page = 1;
                await this.getListData();
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/salecontract/listSel",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        relaBillId:this.relaBillId,
                        page: this.pageInfo.page,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.data;
                    this.pageInfo.total = data.data.count;
                }
                this.dialoading = false;
            },
            rowClick(row){
                let selRows = this.$refs.table.selection;
                let index = selRows.findIndex(item=>{
                    return row == item;
                })
                if(index<0)
                    this.$refs.table.toggleRowSelection(row,true)
                else
                    this.$refs.table.toggleRowSelection(row,false)
            },
            submit(){
                let selRows = this.$refs.table.selection;
                this.$emit("checkRow",selRows);
            },
            //默认选中
            defaultSelect() {
                this.$nextTick(() => {
                    let selrow = this.dataList.find(item => {
                        return item.billId == this.selId
                    })
                    this.$refs.table.setCurrentRow(selrow);
                });
            },
            toPage(obj) {
                this.getListData();
            },
        },
    }
</script>

<style scoped>

    .pagStyle {
        /*margin-bottom: 30px;*/
        /*position:absolute;*/
        width: 100%;
        margin-top: 10px;
        /*bottom: 20px;*/
        text-align: center;
    }


</style>
